import React from 'react'
import { Modal, ModalProps, Typography } from 'antd'
import { CloseIcon } from 'src/assets/icons'
import './index.scss'

const CommonModal: React.FC<
  ModalProps & {
    size?: 'small' | 'middle' | 'large'
    onClose?: () => void
  }
> = (props) => {
  const { children, title, size, onClose, ...rest } = props
  return (
    <Modal className={`common-modal size-${size}`} closeIcon={false} open={true} width={709} centered {...rest}>
      <div>
        <div id='common-container'>
          <div id='common-header'>
            <Typography.Text style={{ fontSize: '22px', fontWeight: 600 }}>{title}</Typography.Text>
            <CloseIcon style={{ cursor: 'pointer' }} onClick={onClose} />
          </div>
          <div id='common-content'>{children}</div>
        </div>
      </div>
    </Modal>
  )
}

export default CommonModal
